import { Location } from '@umss/shared/data-access';
import { AdminNoteDto } from '../common/admin-note.dto';
import { ContractorBankAccountDto } from '../common/contractor-bank-account.dto';
import { ContractorAdminDto } from './contractor-admin.dto';

export interface ContractorAdminDetailDto extends ContractorAdminDto {
  primaryLocation?: Location;
  certifications: string[];
  skills: string[];
  averageRating: number;
  totalRatings: number;
  lastBackgroundCheck?: string | null; // DateTime as ISO string
  notes: AdminNoteDto[];
  primaryBankAccount?: ContractorBankAccountDto | null;
}
